<template>
  <div class="upload com">
    <el-button type="primary" @click="addData" size="small">
      {{ language("shopInformation.addCertificate") }}
    </el-button>
    <!-- 添加登記證 -->
    <div v-for="(item, idx) in fileList" :key="idx" class="uploader-list">
      <cc-uploader
        :config="uploaderConf"
        v-model="fileList[idx].link"
        fType="image"
        @change="updateItem(item, idx)"
        :fFormatV2="['.jpg', '.png', '.pdf']"
      />
      <!-- <CustomUploader :config="uploaderConf" :fSrc="item.link" @change="updateItem($event, idx)" fType="image" info="尺寸" :fFormatV2="['.jpg', '.png']" /> -->
    </div>
  </div>
</template>

<script>
import ossUtils from "../../../../utils/ossUtils";
let Base64 = require("js-base64").Base64;

export default {
  name: "FormUploader",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    formData: Object,
    value: String,
  },

  watch: {
    value: {
      handler(val) {
        this.fileList = this.parse2Json(val);
      },
      immediate: true,
      deep: true,
    },
    formData: {
      handler(val) {
        let url = "/perm/sisMerchant/";
        if (this.formData.merchantNum) {
          url = "/perm/sisMerchant/" + this.formData.merchantNum + "/";
        }
        this.uploaderConf = ossUtils.configPublishV2(url);
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      fileList: this.parse2Json(this.value),
      uploaderConf: ossUtils.configPublish,
    };
  },
  methods: {
    parse2Json(val) {
      try {
        return JSON.parse(val);
      } catch (error) {
        return [];
      }
    },
    addData() {
      this.fileList.push({ link: "", name: "" });
      // this.uploaderData = [...this.uploaderData, { link: '', name: '' }];
    },
    emitUploaderData(arr) {
      this.$emit("change", JSON.stringify(arr));
    },
    updateItem(item, idx) {
      if (!item.link) {
        this.fileList.splice(idx, 1);
        this.emitUploaderData(this.fileList);
        // this.uploaderData.splice(idx, 1);
        return;
      }
      // 上传图片手动触发同步更新操作
      // const arr = this.uploaderData;
      const i = this.fileList[idx];
      i.link = item.link;
      i.name = item.link.split("/").pop();
      i.name = Base64.decode(i.name.split(".")[0]);
      i.name = i.name.split("_")[1];
      this.emitUploaderData(this.fileList);
    },
  },
  updated() {
    //   console.log('update', this.value);
    // this.uploaderData = this.parse2Json(this.value)
  },
  mounted() {},
};
</script>

<style scoped>
.uploader-list {
  margin: 4px 0;
}
</style>
